import { Avatar } from '@getslot/ui-web/avatar'
import { HomeIcon, PlusIcon, UserIcon } from '@getslot/ui-web/icons'
import { SideNav } from '@getslot/ui-web/side-nav'
import { Wordmark } from '@getslot/ui-web/wordmark'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { meQuery } from '../api/queries'
import { isInTelegram } from '../telegram/web-app'
import { RouterSideNavItem } from './links'
import styles from './app-shell.module.css'

/**
 * Каркас веба: на десктопе слева чёрная панель с разделами, справа экран.
 * На телефоне панели нет (разделы в нижней пилюле), в Mini App каркас не рисуется вовсе.
 */
export function AppShell({ children }: { children: ReactNode }) {
  if (isInTelegram()) return children
  return (
    <div className={styles.shell}>
      <div className={styles.side}>
        <SideNav brand={<Wordmark className={styles.wordmark} />} footer={<ProfileLink />}>
          <RouterSideNavItem to="/" activeOptions={{ exact: true }} icon={<HomeIcon />}>
            Главная
          </RouterSideNavItem>
          <RouterSideNavItem to="/new" icon={<PlusIcon />}>
            Новая заявка
          </RouterSideNavItem>
          <RouterSideNavItem to="/profile" icon={<UserIcon />}>
            Профиль
          </RouterSideNavItem>
        </SideNav>
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  )
}

function ProfileLink() {
  const { data: me } = useSuspenseQuery(meQuery)
  return (
    <Link to="/profile" className={styles.profile}>
      <Avatar name={me.display_name} />
      <span className={styles.who}>
        <span className={styles.name}>{me.display_name ?? 'Без имени'}</span>
        <span className={styles.sub}>вход через Telegram</span>
      </span>
    </Link>
  )
}
